import * as React from "react";
import type { State } from "../../reducer";
import { initialState } from "../../reducer";

export type ContextType = State;

const GameReducerStateContext: React.Context<ContextType> = React.createContext<ContextType>(initialState);

export default GameReducerStateContext;
